import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-list-actions',
  template: `
    <div class="list-actions">
      <span class="list-actions-label">
        <span class="badge-rounded badge-gray">{{
          totalItemsSelected ? totalItemsSelected : 0
        }}</span>
        {{ selectedLabel }}:
      </span>
      <div class="btn-group">
        <span class="btn dropdown-toggle" data-toggle="dropdown">
          Update status <i class="fa fa-angle-down"></i>
        </span>
        <ul class="dropdown-menu">
          <li [hidden]="hideActivateButton || !permissions.canUpdate">
            <a class="cursor" (click)="updateItems('activate')">
              <i class="fa fa-check-square"></i> Activate
            </a>
          </li>
          <li [hidden]="hideActivateButton || !permissions.canUpdate">
            <a class="cursor" (click)="updateItems('deactivate')">
              <i class="fa fa-minus-square"></i> Deactivate
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        class="btn btn-danger"
        [hidden]="hideDeleteButton || !permissions.canDestroy"
        (click)="deleteItems()"
        style="margin-left: 5px;"
      >
        Delete
      </button>
    </div>
  `,
})
export class ListActionsComponent implements OnInit {
  @Input() showListActions: boolean;
  @Input() totalItems: number;
  @Input() totalItemsSelected: number;
  // @Input() label: string;
  @Input() permissions: any;
  @Input() hideActivateButton: boolean = false;
  @Input() hideDeleteButton: boolean = true;

  @Output() private updatedItems = new EventEmitter<any>();
  @Output() private deletedItems = new EventEmitter<any>();

  selectedLabel = '';

  ngOnInit() {
    this.selectedLabel = this.totalItemsSelected < 9 ? 'SELECTED' : 'SELECTEDS';
  }

  updateItems(option) {
    this.updatedItems.emit(option);
  }

  deleteItems() {
    this.deletedItems.emit();
  }
}

// here we can use a service and emit an observable, in the parent compoment we subscribe and destroy later
// This way we do not need to use callbacks
// well which service ?????
